<template>
  <div class="insight-header">
    <div
      v-if="!loading"
      class="preamble-content"
    >
      <slot name="header:bottom">
        <InsightMessageBanner
          :header="reportingMessage.header"
          :message="reportingMessage.message"
          :beacon-article-id="reportingMessage.beaconArticleId"
          :data-png-remove="reportingMessage.dataPngRemove"
          @close="$emit('close')"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import InsightMessageBanner from '@/components/insights/InsightMessageBanner.vue';

export default {
  name: 'InsightHeader',
  components: { InsightMessageBanner },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    reportingMessage: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
};
</script>

<style lang="less" scoped>
.insight-header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.header-link {
  font-weight: 400;
}

.preamble-content {
  width: 100%;
}
</style>
